import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "../theme";
import { Layout } from "./Layout";
import Routes from "./Routes";

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <Routes />
        </Layout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
